import { atom, useAtom, useSetAtom } from "jotai";
import { useEffect } from "react";
import { useWindowSize as useWindowSizeHook } from "usehooks-ts";

export const windowSizeAtom = atom<{ width: number; height: number }>({
    width: window.innerWidth,
    height: window.innerHeight,
});
export function useWindowSizeListener() {
    const newWindowSize = useWindowSizeHook({ debounceDelay: 200 });
    const setWindowSize = useSetAtom(windowSizeAtom);
    useEffect(() => {
        setWindowSize({
            width: newWindowSize.width,
            height: newWindowSize.height,
        });
    }, [newWindowSize]);
}

export function useWindowSize() {
    const [windowSize] = useAtom(windowSizeAtom);
    return windowSize;
}
